import { render, staticRenderFns } from "./SettingsMonitoring.vue?vue&type=template&id=345edb69&scoped=true&"
import script from "./SettingsMonitoring.vue?vue&type=script&lang=js&"
export * from "./SettingsMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMonitoring.vue?vue&type=style&index=0&id=345edb69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345edb69",
  null
  
)

export default component.exports